document.addEventListener("alpine:init", () => {
  Alpine.data(
    "Theme_3D_Slideshow",
    ({
      onlyIfNeeded = false,
      ...options
    }) => ({
      options,
      playing: false,
      Swiper: null,
      rate: 0,
      onlyIfNeeded,
      maxLgBreakpointMQL: window.matchMedia("(max-width: 1023px)"),
      init() {
        if (typeof Swiper === "undefined") {
          console.error(
            "slideshows.js requires a Swiper object to be defined in the global scope"
          );

          return;
        }

        this.initSwiper();
        const _this = this;
        if(this.$refs.progressBar){
          this.$root.addEventListener('move', function(evt){
            _this.$refs.progressBar.style.width = evt.detail.progress.toString() + '%';
          })
        }

        if (this.onlyIfNeeded) {
          this.destroyOrInitIfNeeded();

          this.maxLgBreakpointMQL.addEventListener("change", (e) => {
            this.destroyOrInitIfNeeded();
          });
        }

        if (Shopify.designMode) {
          this._setUpDesignModeHandlers();
        }

        document.addEventListener("dev:hotreloadmutation", async () => {
          if (!Shopify.designMode) {
            this.Swiper.destroy();

            await this.$nextTick();

            this.initSwiper();
          }
        });
      },
      initSwiper() {
        const options = {
          ...this.options,
        };

        this.Swiper = new Swiper(this.$root, options);

      },
      destroyOrInitIfNeeded() {
        const slideEls = Array.from(
          this.$root.querySelectorAll(".swiper__slide")
        );

        const totalSlidesWidth = slideEls.reduce(
          (totalWidth, slideEl) =>
            totalWidth + slideEl.getBoundingClientRect().width,
          0
        );

        const totalGridlinesWidth =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              "--gridline-width"
            )
          ) *
          (slideEls.length - 1);

        const totalContentWidth = totalSlidesWidth + totalGridlinesWidth;

        if (totalContentWidth <= this.$root.getBoundingClientRect().width) {
          if (SwiperIsNotDestroyed(this.Swiper)) this.Swiper.destroy();
        } else {
          if (!SwiperIsNotDestroyed(this.Swiper)) this.initSwiper();
        }
      },
      _setUpDesignModeHandlers() {
        this.$root.addEventListener("slideshow-go", (e) => {
          if (!e.detail) return;

          this.Swiper.go(parseInt(e.detail, 10));
        });
      },
    })
  );
});
